import React, { useState } from "react";

import { Button, Modal } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";

const CustomModal = ({
  children,
  className = "",
  show,
  title,
  onClose = null,
}) => {
  return (
    <>
      {show && (
        <>
          <Modal
            show={show}
            className={className}
            onHide={() => {
              console.log("onClose :", typeof onClose);

              if (typeof onClose == "function") {
                console.log("here");

                onClose();
              }
            }}
          >
            <Modal.Header closeButton={onClose ? true : false}>
              <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{children}</Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
};

export default CustomModal;
